module.exports = __webpack_public_path__ + "img/chat_icon8.4c396834.png";